import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileImage,
  faFileAlt,
  faFolderOpen,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary};
`;

const SetFileIcon = ({ url }) => {
  const setIcon = url?.match(/\.zip$/i) ? (
    <StyledIcon icon={faFolderOpen} size="2x" />
  ) : url?.match(/\.png$/i) || url?.match(/\.jpg$/i) ? (
    <StyledIcon icon={faFileImage} size="2x" />
  ) : url?.match(/\.pdf$/i) ? (
    <StyledIcon icon={faFilePdf} size="2x" />
  ) : url?.match(/\.xlsx$/i) || url?.match(/\.xls/i) ? (
    <StyledIcon icon={faFileExcel} size="2x" />
  ) : (
    <StyledIcon icon={faFileAlt} size="2x" />
  );
  return setIcon;
};

SetFileIcon.propTypes = {
  url: PropTypes.string,
};

export default SetFileIcon;
